/**
 * Bill Payments Service Page
 */
import React from 'react';
import ServicePageLayout from '../../landing/components/service-pages/ServicePageLayout';
import billPaymentsConfig from '../data/billPaymentsConfig';

const BillPaymentsPage = () => {
  return <ServicePageLayout config={billPaymentsConfig} />;
};

export default BillPaymentsPage;
